import type { CSSProperties } from 'react';
import { getPlatformBrand } from '@/utils/platform';

interface PlatformIconProps {
  /** Platform name as stored in the data, e.g. "TikTok", "Instagram", "X". */
  platform: string;
  /** Sizing / layout classes, e.g. "text-base" or "text-[13px]". */
  className?: string;
  /** Hover tooltip; defaults to the official platform name. */
  title?: string;
  /** Render in the surrounding text color instead of the brand color (for dark or saturated chips). */
  mono?: boolean;
}

export default function PlatformIcon({
  platform,
  className = 'text-base',
  title,
  mono = false,
}: PlatformIconProps) {
  const brand = getPlatformBrand(platform);

  if (!brand) {
    return (
      <i
        className={`ri-links-line text-foreground-400 ${className}`}
        title={title ?? platform}
        aria-hidden="true"
      />
    );
  }

  const style: CSSProperties | undefined = mono
    ? undefined
    : brand.gradient
      ? {
          backgroundImage: brand.gradient,
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          color: 'transparent',
          WebkitTextFillColor: 'transparent',
        }
      : { color: brand.color };

  return (
    <i
      className={`${brand.icon} ${className}`}
      style={style}
      title={title ?? brand.label}
      aria-hidden="true"
    />
  );
}